import { render } from "./PaymentCancel.vue?vue&type=template&id=1c219bed&scoped=true"
import script from "./PaymentCancel.vue?vue&type=script&lang=js"
export * from "./PaymentCancel.vue?vue&type=script&lang=js"

import "./PaymentCancel.vue?vue&type=style&index=0&id=1c219bed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c219bed"]])

export default __exports__